"use strict";

var Good = function () {

  var calculate_duty_with_formul = function() {
    var duty_calc_formul = $('#good_calc_formul_src').val();
    var [kgm, dtn, tne, adsz, adfm, ea, supp_unit, third_qty] = [0,0,0,0,0,0,0,0];
    var invoice_amount = parseFloat($('#good_invoice_amount').val()) || 0;
    var calc_wg = parseFloat($('#good_brut_wg').val()) || 0;
    if ($('#good_net_wg').val() !== '' && $('#good_net_wg').val() !== null) {
      var net_wg = parseFloat($('#good_net_wg').val()) || 0;
      if (net_wg > 0) {
        calc_wg = net_wg;
      }
    }

    if (duty_calc_formul.includes("KGM")) {
      kgm  = calc_wg;
    }
    if (duty_calc_formul.includes("DTN") || duty_calc_formul.includes("ADSZ") || duty_calc_formul.includes("ADFM") || duty_calc_formul.includes("EA")) {
      dtn  = (calc_wg/100).toFixed(2);
      if (duty_calc_formul.includes("ADSZ")) {
        adsz = (dtn * 38.99).toFixed(2);
      }
      if (duty_calc_formul.includes("ADFM")) {
        adfm = (dtn * 19.09).toFixed(2);
      }
      if (duty_calc_formul.includes("EA")) {
        ea   = (dtn * 275.82).toFixed(2);
      }
    }
    if (duty_calc_formul.includes("TNE")) {
      tne  = (calc_wg/1000).toFixed(3);
    }

    var eur_rate  = parseFloat($('#good_curr_rate').val()) || 1;
    supp_unit = parseFloat($('#good_supplementary_unit').val()) || 0;
    third_qty = parseFloat($('#good_third_quantity').val()) || 0;
    var supp_unit_unit = $('#good_supplementary_unit_text').val();
    var third_qty_unit = $('#third_quantity_unit').val();
    var duty_amount    = 0

    var calculation_vars = {
        KGM: kgm,
        DTN: dtn,
        TNE: tne,
        ADSZ: adsz,
        ADFM: adfm,
        EA: ea,
        VALUE: invoice_amount,
        EUR: eur_rate
    };
    var good_calc_formula = duty_calc_formul.replace(/KGM|DTN|TNE|ADSZ|ADFM|EA|VALUE/gi, function(matched_key) {
      return calculation_vars[matched_key];
    });
    if (supp_unit_unit !== '' && supp_unit_unit !== null) {
      good_calc_formula = good_calc_formula.replace(supp_unit_unit, supp_unit);
    }
    if (third_qty_unit !== '' && third_qty_unit !== null) {
      good_calc_formula = good_calc_formula.replace(third_qty_unit, third_qty);
    }
    if (good_calc_formula.includes("%")) {
      good_calc_formula = good_calc_formula.replace('%', '/100');
    }
    $('#good_calc_formul').val(good_calc_formula);
    if (good_calc_formula.includes("EUR")) {
      good_calc_formula = good_calc_formula.replace('EUR', eur_rate);
    }

    try {
      duty_amount = eval(good_calc_formula);
    }
    catch(err) {
      console.log('Duty calc. eval error message: ' + err.message);
      duty_amount = 0;
    }

    $('#good_duty_amount').val(duty_amount.toFixed(2));
  };

  var calculate_duty_amount = function() {
    var duty_calc_formul = $('#good_calc_formul_src').val();
    if ((duty_calc_formul !== '') && (duty_calc_formul !== null) && (typeof duty_calc_formul !== typeof undefined)) {
      calculate_duty_with_formul();
    } else {
      $('#good_calc_formul').val(null);
      var invoice_amount = parseFloat($("#good_invoice_amount").val()) || 0;
      var duty_rate      = parseFloat($("#good_duty_rate").val()) || 0;
      console.log('Calculating Duty with rate : ' + duty_rate);
      if (duty_rate !== 0) {
        $("#good_duty_amount").val(parseFloat((invoice_amount * duty_rate) / 100).toFixed(2));
      }
    }
  };

  var calculate_excise_amount = function() {
    var invoice_amount = parseFloat($("#good_invoice_amount").val()) || 0;
    var excise_rate    = parseFloat($("#good_excise_rate").val()) || 0;
    console.log('Calculating Excise with rate : ' + excise_rate);
    if (excise_rate !== 0) {
      $("#good_excise_amount").val(parseFloat((invoice_amount * excise_rate) / 100).toFixed(2));
    }
  };

  var calculate_vat_amount = function() {
    var duty_amount, excise_amount, invoice_amount, vat_rate, vat_amount;
    vat_rate = parseFloat($("#good_vat_rate").val()) || 0;
    console.log('Calculating VAT with rate : ' + vat_rate);
    if (vat_rate > 0) {
      invoice_amount = parseFloat($("#good_invoice_amount").val()) || 0;
      duty_amount = parseFloat($("#good_duty_amount").val()) || 0;
      excise_amount = parseFloat($("#good_excise_amount").val()) || 0;
      vat_amount = parseFloat((invoice_amount + duty_amount + excise_amount) * vat_rate / 100);
      return $("#good_vat_amount").val(vat_amount.toFixed(2));
    } else {
      return $("#good_vat_amount").val(0);
    }
  };

  var calculate_taxes = function() {
    calculate_duty_amount();
    calculate_excise_amount();
    return calculate_vat_amount();
  }

  return {
    init: function () {
      $(document).on("change", "#good_invoice_amount", function(event) {
        calculate_taxes();
      });

      $(document).on("change", "#good_duty_rate", function(event) {
        calculate_duty_amount();
        return calculate_vat_amount();
      });

      $(document).on("change", "#good_excise_rate", function(event) {
        calculate_excise_amount();
        return calculate_vat_amount();
      });

      $(document).on("change", ["#good_brut_wg", "#good_net_wg"], function(event) {
        calculate_taxes();
      });

      $(document).on("change", ["#good_brut_wg", "#good_net_wg", "#good_calc_formul_src"], function(event) {
        calculate_taxes();
      });

      $(document).on("change", "#good_vat_rate", function(event) {
        return calculate_vat_amount();
      });

      $(document).on("change", ["#good_duty_amount", "#good_excise_amount"], function(event) {
        return calculate_vat_amount();
      });
    },
    calculate_taxes: function () {
      calculate_taxes();
    },
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Good;
}